<template>
  <li class="budget-manual-actions__list-item">
    <p>{{ label }} <i v-tooltip="tooltip" class="icon-info-circle" /></p>

    <div :class="manualActionClass">
      <span v-if="showPercentage" class="budget-manual-actions__append-to-input"
        >%</span
      >

      <input
        v-model="currentValue"
        type="text"
        class="budget-manual-actions__input"
      /><a
        role="link"
        class="budget-manual-actions__link sf-btn"
        @click="submit"
      >
        <div v-if="processing" class="sf-spinner sf-inline-block" />
        <i v-else role="icon" :class="iconClass" />
      </a>
    </div>
  </li>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import type { Action, ManualActionNames } from '../types'

interface Props {
  manualActionType: ManualActionNames
  defaultValue: string
  label: string
  iconClass: string
  previousAction: Action | null
  tooltip: string
  processing: boolean
  showPercentage: boolean
  error: boolean
}

const emit =
  defineEmits<{
    (
      _e: 'submit',
      _payload: {
        value: string
        actionType: ManualActionNames
      }
    ): void
  }>()

const props = withDefaults(defineProps<Props>(), {
  error: false,
  showPercentage: false,
  previousAction: null,
  processing: false,
})

const manualActionClass = computed(() => {
  return {
    'budget-manual-actions__action': true,
    'budget-manual-actions__empty-value': props.error,
  }
})

const currentValue = ref(
  props.previousAction &&
    props.previousAction.type === props.manualActionType &&
    props.previousAction.value
    ? props.previousAction.value.replace('%', '')
    : props.defaultValue
)

function submit(): void {
  if (currentValue.value) {
    emit('submit', {
      value: currentValue.value,
      actionType: props.manualActionType,
    })
  }
}
</script>

<style scoped lang="scss">
@import 'silverfin-ui-kit/src/scss/tooling';

.budget-manual-actions {
  $select-chrevon-position: 22px;

  &__list-item {
    margin: 0 0 12px;
  }

  &__action {
    border: 1px solid -color('snow', 'dark');
    border-radius: 4px;
    height: 100%;
    position: relative;
    display: flex;
  }

  &__link {
    border: none;
    border-left: 1px solid -color('snow', 'dark');
    border-radius: 0 4px 4px 0;
    box-shadow: none;
    padding: 2px 4px;
  }

  &__input {
    border: none;
    box-shadow: none;
    height: auto;
    border-radius: 4px 0 0 4px;
    width: initial;
    flex-grow: 1;
    padding: 2px 4px;
    vertical-align: top;
    margin: 0;

    @include background-color('snow', 'light');
    @include font-size('body', 'xs');
  }

  &__empty-value {
    border-color: -color('danger');
  }

  &__append-to-input {
    position: absolute;
    top: 50%;
    right: calc($select-chrevon-position + 6px);
    transform: translate(0, -50%);
  }
}
</style>
